const GettingStarted = () => {
  return (
    <>
      <div className="alert alert-info mt-5 mb-3">
        <p>Welcome to your initial project setup. Here's what's included:</p>

        <ul>
          <li>
            An invoice listing page at{' '}
            <code>app/components/InvoicesList/index.tsx</code>
          </li>
          <li>
            An invoice details page at{' '}
            <code>app/components/InvoicesShow/index.tsx</code>
          </li>
          <li>
            <code>react-router</code> for navigation between pages
          </li>
        </ul>

        <p>
          This project uses TypeScript by default. If you prefer not to use
          TypeScript, you can remove it by running <code>yarn eject_ts</code>.
        </p>

        <p>Please review the README for important API interaction details.</p>

        <p>
          We've provided pre-built components in the <code>ui</code> folder.
        </p>
        <p>
          While <code>react-hook-form</code> is available, you're free to use
          any form handling solution you prefer.
        </p>
      </div>
    </>
  )
}

export default GettingStarted
